import { DatePipe } from '@angular/common';
import { Directive, Input, inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ProductAddToBasketComponentDef } from '@df/catalog-ui/product/add-to-basket/product-add-to-basket.component.def';
import { IScrollToOptions } from '@df/dom/scroll/scroll-to.service';
import { Giftcards } from '@df/module-giftcards/giftcards';
import { ScrollToErrorService } from '@df/ui/form/scroll-to-error.service';
import { Nexus } from '@tomandco/nexus-api-types';

const datePipe = new DatePipe('en-GB');

/**
 * WARNING: please note this is NOT to be used with product configuration
 */
@Directive()
export abstract class GiftcardsAddToBasketComponentDef extends ProductAddToBasketComponentDef {
    @Input()
    form?: NgForm;

    @Input()
    request?: Giftcards.ISelectionContainer;

    private scrollToErrorService = inject(ScrollToErrorService);

    buyGiftcard(): void {
        if (this.request && this.form) {
            this.request.is_send_to_myself = this.request.recipientType === Giftcards.ERecipientType.myself ? 1 : 0;
            this.form.submitAttempt = true;
            this.form.ngSubmit.emit();
            if (this.form.valid) {
                this.submit();
            } else {
                this.scrollToErrorService.scrollTo(this.getErorrContainer(), this.getScrollToErrorOptions());
            }
        }
    }

    protected getErorrContainer(): HTMLElement {
        return document.body;
    }

    protected getScrollToErrorOptions(): IScrollToOptions | undefined {
        return undefined;
    }

    override emitSuccess(): void {
        super.emitSuccess();
        this.form!.submitAttempt = false;
    }

    protected override getRequest(): Nexus.Lib.Basket.AddToBasketData[] | undefined {
        const request = { ...(this.request! as Giftcards.ISelectionContainer & Nexus.Lib.Basket.AddToBasketData) };

        request.id = this.product?.id || 0;
        request.qty = this.qty || 1;

        if (!request.am_giftcard_amount) {
            request.am_giftcard_amount = request.am_giftcard_amount_custom;
        }

        const skip = ['am_giftcard_amount_custom', 'recipientType'];

        if (request.recipientType === Giftcards.ERecipientType.myself || request.is_send_to_myself === 1) {
            skip.push(
                'am_giftcard_recipient_email',
                'am_giftcard_recipient_name',
                'am_giftcard_sender_email',
                'am_giftcard_sender_name',
                'am_giftcard_message'
            );
            request.is_send_to_myself = 1;
        } else {
            request.is_send_to_myself = 0;
        }

        skip.forEach(field => {
            if (Object.prototype.hasOwnProperty.call(request, field)) {
                delete request[field];
            }
        });

        if (request.am_giftcard_date_delivery) {
            request.am_giftcard_date_delivery = datePipe.transform(request.am_giftcard_date_delivery, 'MM/dd/yyyy') || undefined;
        }

        return this.app.customer.basket.normalizeAddToBasketData(request);
    }
}
